import { type GridColDef } from "@mui/x-data-grid";

import { AdminPolicyLetter } from "api/memberPortal/policies/policies.types";
import { dataGridDateGetter } from "components/MUI/DataGrid/DataGrid.utils";

import PolicyLettersActionsCell from "./PolicyLettersActions.cell";

interface PolicyLettersColumnActions {
  onEdit: (_policy: AdminPolicyLetter) => void;
  onDelete: (_id: number) => void;
}

export const buildPolicyLettersColumns = ({
  onEdit,
  onDelete,
}: PolicyLettersColumnActions): GridColDef<AdminPolicyLetter>[] => [
  {
    headerName: "No.",
    field: "policy_num",
    flex: 1,
  },
  {
    headerName: "Update No.",
    field: "update_num",
    flex: 1,
  },
  {
    headerName: "Addendum No.",
    field: "addendum_num",
    flex: 1,
  },
  {
    headerName: "Superseded No.",
    field: "superseded_num",
    flex: 1,
  },
  {
    headerName: "Title",
    field: "policy_title",
    flex: 4,
  },
  {
    headerName: "Date",
    field: "policy_date",
    type: "date",
    flex: 1,
    valueGetter: dataGridDateGetter,
  },
  {
    headerName: "Author",
    field: "author",
    flex: 1,
  },
  {
    headerName: "ID",
    field: "policy_id",
    flex: 1,
  },
  {
    headerName: "Actions",
    field: "",
    flex: 1,
    sortable: false,
    filterable: false,
    type: "actions",
    renderCell: ({ row }) => (
      <PolicyLettersActionsCell
        policy={row}
        onEdit={() => onEdit(row)}
        onDelete={() => onDelete(row.policy_id)}
      />
    ),
  },
];
